import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from '@/layouts/AppShell'
import { RequireAuth, RequireClient } from './guards'
import { LoginPage } from '@/features/login/LoginPage'
import { CallbackPage } from '@/features/login/CallbackPage'
import { ClientsPage } from '@/features/clients/ClientsPage'
import { ClientProfilePage } from '@/features/client-profile/ClientProfilePage'
import { CrawlPage } from '@/features/crawl/CrawlPage'
import { ProgramsPage } from '@/features/programs/ProgramsPage'
import { QuotesPage } from '@/features/quotes/QuotesPage'
import { MediaPage } from '@/features/media/MediaPage'
import { FactsPage } from '@/features/facts/FactsPage'
import { CopyPage } from '@/features/copy/CopyPage'
import { BrandPage } from '@/features/brand/BrandPage'
import { NotFoundPage } from '@/features/not-found/NotFoundPage'

/**
 * Route table per docs/02-app-shell.md §3.
 *
 * `/c/:clientId` is the single source of truth for tenant scope: no client id
 * in React state, none in localStorage as the authority. localStorage holds a
 * last-visited id only, as a convenience for redirecting `/`.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Unguarded, and must stay that way: the user is not authenticated yet
          when Auth0 redirects here with the authorization code. */}
      <Route path="/callback" element={<CallbackPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<ClientsPage />} />

          <Route path="c/:clientId" element={<RequireClient />}>
            <Route index element={<Navigate to="crawl" replace />} />
            <Route path="profile" element={<ClientProfilePage />} />
            <Route path="crawl" element={<CrawlPage />} />
            <Route path="programs" element={<ProgramsPage />} />
            <Route path="quotes" element={<QuotesPage />} />
            <Route path="media" element={<MediaPage />} />
            <Route path="facts" element={<FactsPage />} />
            <Route path="copy" element={<CopyPage />} />
            <Route path="brand" element={<BrandPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
